<template>
  <div class="list-meeting-container">
    <ul class="list-meeting-content">
      <div v-if="meetingItems.length === 0" class="text-center mt-80">
        予約はありません
      </div>
      <li v-for="meeting in meetingItems"
          v-if="!checkMeetingBetweenMonths(meeting)"
          :key="meeting.id"
          :style="`border-left:5px solid ${meeting.category.color};`"
          class="meeting-item clearfix"
          :class="getMeetingStatus(meeting)"
          @click="handleClickMeeting(meeting)"
      >
        <!--Meeting info-->
        <div class="info">
          <div v-if="checkDifferenceEndYearWithStartYear(meeting)"
            :class="{'special-meeting': checkDifferenceEndYearWithStartYear(meeting)}"
            class="date special-meeting"
          >
            {{meeting.start_at | meetingTimeDisplay(meeting.end_at)}}
          </div>
          <div v-else class="date">{{meeting.start_at | meetingTimeDisplay(meeting.end_at)}}</div>
          <div class="title" :class="{'title-special-meeting': checkDifferenceEndYearWithStartYear(meeting)}">
            {{meeting.title || `#${meeting.id}`}}
          </div>
        </div>
        <!--/Meeting info-->

        <!--Meeting members list-->
        <div class="participants">
          <div v-if="meeting.status !== 'discontinuation'">
            <div v-if="meeting.pharmacy">
              <el-tooltip class="item" effect="dark" placement="left">
                <div slot="content">
                  <div class="more-users-tooltip">{{meeting.pharmacy.pmc_name}}</div>
                  <div v-if="meeting.user" class="more-users-tooltip">{{`${meeting.user.name} (患者)`}}</div>
                </div>
                <el-button class="show-more-users">
                  <p class="users-meeting"
                     :class="{ending: getMeetingStatus(meeting) === MEETING_ENDING || meeting.status === 'canceled'}">
                    {{meeting.pharmacy.pmc_name}}</p>
                </el-button>
              </el-tooltip>
            </div>
            <div v-else>
              <div v-if="meeting.participants.length === 0" class="show-more-users">
                {{meeting.user.name}}
              </div>
              <div v-else>
                <el-tooltip class="item" effect="dark" placement="left">
                <div slot="content">
                  <div v-for="item in meeting.participants" class="more-users-tooltip" :key="item.id">
                    {{item.user_name}}
                    <span v-if="item.user_type === 0">(患者)</span>
                    <span v-else-if="item.user_type === 1">(薬剤師)</span>
                    <span v-else-if="item.user_type === 2 && item.occupation">({{item.occupation}})</span>
                  </div>
                </div>
                <el-button v-if="meeting.participants.length > 0" class="show-more-users">
                  <div class="users-meeting">
                    <p v-if="meeting.user"
                       class="user-name inline-block"
                       :class="{ending: getMeetingStatus(meeting) === MEETING_ENDING}"
                    >
                      {{meeting.user.name}}
                    </p>
                    <p class="inline-block"
                       :class="{ending: getMeetingStatus(meeting) === MEETING_ENDING}"
                       v-if="meeting.participants && meeting.participants.length > 0"
                    >、他{{meeting.participants.length}}名</p>
                  </div>
                </el-button>
              </el-tooltip>
              </div>
            </div>
          </div>
        </div>
        <!--/Meeting members list-->

        <!--Meeting status-->
        <div class="status">
          <span v-if="meeting.status === 'pending' && isOverTime(meeting)">
            <span class="text-danger">取消</span>
          </span>
          <span v-else-if="meeting.status === 'pending' && !isOverTime(meeting)">
            <span class="text-warning">申請中</span>
          </span>
          <span v-else>
            <span v-if="getMeetingStatus(meeting) === MEETING_ENDING">終了</span>
            <span v-else-if="meeting.status === 'discontinuation'">中止</span>
            <span v-else-if="meeting.status === 'accepted'" class="text-success">確定</span>
            <span v-else-if="meeting.status === 'canceled'" class="text-danger">取消</span>
          </span>
        </div>
        <!--/Meeting status-->

        <!--Meeting actions-->
        <div class="actions">
          <template>
            <span v-if="isAbleCancelMeeting(meeting) ">
              <span @click.stop="handleClickCancelMeeting(meeting)"
                    v-if="meeting.status === 'pending' && !meeting.is_approver && !isOverTime(meeting)"
                    class="button small danger"
                    :class="{disabled: isSubmittingMeeting(meeting.id)}"
              >取消</span>
            </span>
            <span v-else>
              <span v-if="meeting.status === 'pending' && !meeting.is_approver"
                    @click.stop="showErrorMessage('This meeting is taking place')"
                    class="button small danger disabled"
              >取消</span>
            </span>
            <span v-if="meeting.status === 'pending' && meeting.is_approver && !isOverTime(meeting)" class="inline-block">
              <span @click.stop="handleClickAcceptMeeting(meeting)"
                    class="button small info"
                    :class="{disabled: isSubmittingMeeting(meeting.id)}"
              >承認</span>
              <span @click.stop="handleClickCancelMeetingByPharmacist(meeting)"
                    class="button small danger"
                    :class="{disabled: isSubmittingMeeting(meeting.id)}"
              >辞退</span>
            </span>
            <span v-if="isShowBtnDetail(meeting)"
                  @click.stop="handleClickDetailMeeting(meeting)"
                  class="button small default"
            >詳細</span>
          </template>
        </div>
        <!--/Meeting actions-->
      </li>
    </ul>
    <div class="overlay-modal" v-if="showModal">
      <div class="modal-content">
        <div class="modal-header"></div>
        <div class="modal-body">
          <span class="block mb-5">辞退理由（必須）</span>
          <el-input
            type="textarea"
            :rows="7"
            placeholder=""
            v-model="messageDeleteMeeting">
          </el-input>
        </div>
        <div class="modal-footer">
          <span class="cancel-btn" @click="showModal = false">操作を取消し</span>
          <span
            v-if="messageDeleteMeeting.length > 0 && !(selectedMeeting && isSubmittingMeeting(selectedMeeting.id))"
            class="confirm-btn"
            @click="cancelMeetingByPharmacist()"
          >送信</span>
          <span v-else class="confirm-btn banned">送信</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {MEETING_ENDING, CANCEL_TYPE_REJECT} from '../../const'
import {getMeetingStatus, isPatientUser, isPharmacistUser, isOtherUser, apiErrorDialog} from '../../helpers'
import moment from 'moment'

export default {
  data () {
    return {
      MEETING_ENDING,
      CANCEL_TYPE_REJECT,
      showModal: false,
      messageDeleteMeeting: '',
      selectedMeeting: null,
      submittingMeetingIds: []
    }
  },
  props: {
    loading: {type: Boolean, required: false},
    month: {type: Number, required: false}
  },
  computed: {
    ...mapGetters({
      meetingItems: 'meetings/items'
    })
  },
  methods: {
    ...mapActions({
      fetchMeetingItems: 'meetings/fetchMeetings',
      cancelMeeting: 'meetings/cancelMeeting',
      acceptMeeting: 'meetings/acceptMeeting',
      removeMeeting: 'meetings/removeMeeting'
    }),
    getMeetingStatus,
    isPatientUser,
    isPharmacistUser,
    isOtherUser,
    isSubmittingMeeting (meetingId) {
      return this.submittingMeetingIds.indexOf(meetingId) !== -1
    },
    startSubmittingMeeting (meetingId) {
      if (this.isSubmittingMeeting(meetingId)) return false
      this.submittingMeetingIds = this.submittingMeetingIds.concat([meetingId])
      return true
    },
    finishSubmittingMeeting (meetingId) {
      this.submittingMeetingIds = this.submittingMeetingIds.filter(id => id !== meetingId)
    },
    async reloadMeetings () {
      await this.fetchMeetingItems({params: null, callbacks: {error: (error) => apiErrorDialog(this, error)}})
    },
    async handleActionError (error) {
      if (error && error.response && error.response.status === 409) {
        this.$message.warning('状態が変更されました。最新情報を再取得します。')
        await this.reloadMeetings()
        return
      }
      apiErrorDialog(this, error)
    },
    isOverTime (meeting) {
      return moment() > moment(meeting.end_at)
    },
    isShowBtnDetail (meeting) {
      const endAt = moment(meeting.end_at)
      const now = moment()
      if (meeting.status === 'pending' && endAt.isAfter(now)) return false
      return true
    },
    checkDifferenceEndYearWithStartYear (meeting) {
      const startYear = moment(meeting.start_at).year()
      const endYear = moment(meeting.end_at).year()
      if (startYear !== endYear) {
        return true
      }
      return false
    },
    handleClickCancelMeetingByPharmacist (meeting) {
      this.showModal = true
      this.selectedMeeting = meeting
    },
    async cancelMeetingByPharmacist () {
      if (!this.selectedMeeting || !this.startSubmittingMeeting(this.selectedMeeting.id)) return
      try {
        const canceledMeeting = await this.cancelMeeting({
          params: {
            id: this.selectedMeeting.id,
            message: this.messageDeleteMeeting,
            cancel_type: CANCEL_TYPE_REJECT,
            expected_status: this.selectedMeeting.status
          },
          callbacks: {error: async (error) => this.handleActionError(error)}
        })
        if (!canceledMeeting) return
        this.showModal = false
        this.messageDeleteMeeting = ''
        this.$message.success('この予約は正常に取り消されました!')
      } catch (e) {
        await this.handleActionError(e)
      } finally {
        this.finishSubmittingMeeting(this.selectedMeeting.id)
      }
    },
    handleClickCancelMeeting (meeting) {
      if (this.isSubmittingMeeting(meeting.id)) return
      this.$confirm('本当に取り消しますか？', '警告', {
        confirmButtonText: 'はい',
        cancelButtonText: 'キャンセル',
        type: 'warning'
      }).then(async () => {
        if (!this.startSubmittingMeeting(meeting.id)) return
        try {
          const canceledMeeting = await this.cancelMeeting({
          params: {
              id: meeting.id,
              expected_status: meeting.status
          },
            callbacks: {error: async (error) => this.handleActionError(error)}
          })
          if (!canceledMeeting) return
        } finally {
          this.finishSubmittingMeeting(meeting.id)
        }
      }).catch(() => {})
    },
    handleClickAcceptMeeting (meeting) {
      if (this.isSubmittingMeeting(meeting.id)) return
      this.$confirm('この申請を承認しますか？', '警告', {
        confirmButtonText: '承認する',
        cancelButtonText: '操作を取消',
        type: 'warning'
      }).then(async () => {
        if (!this.startSubmittingMeeting(meeting.id)) return
        try {
          const acceptedMeeting = await this.acceptMeeting({
            id: meeting.id,
            expected_status: meeting.status,
            callbacks: {error: async (error) => this.handleActionError(error)}
          })
          if (!acceptedMeeting) return
          if (this.$route.name === 'pending-meetings') {
            this.removeMeeting(meeting.id)
          }
        } finally {
          this.finishSubmittingMeeting(meeting.id)
        }
      }).catch(() => {})
    },
    handleClickDetailMeeting (meeting) {
      this.$router.push({name: 'meetings.show', params: {id: meeting.id}})
    },
    isAbleCancelMeeting (meeting) {
      if (meeting.status === 'pending') return true
      const start = meeting.start_at
      const now = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
      return !moment(now).isAfter(start)
    },
    showErrorMessage (msg) {
      this.$message.error(msg)
    },
    handleClickMeeting (meeting) {
      if (meeting.status === 'pending') return
      this.handleClickDetailMeeting(meeting)
    },
    checkMeetingBetweenMonths (meeting) {
      const start = moment(meeting.start_at)
      const end = moment(meeting.end_at)
      return (start.month() + 1, end.month() + 1, parseInt(this.month), start.month() + 1 === end.month() + 1 && start.month() + 1 !== parseInt(this.month))
    }
  },
  async mounted () {
    // const loading = this.$loading.show()
    // await this.fetchMeetingItems({params: null})
    // loading.hide()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/meetings/ListMeeting.vue